const accordionItem = document.querySelectorAll(".bm-accordion-item");
const accordionTitles = document.querySelectorAll(".bm-accordion-title");
const accordionContents = document.querySelectorAll(".bm-accordion-content");

accordionItem.forEach((item) => {
    item.querySelector(".bm-accordion-title").addEventListener("click", () => {
        accordionItem.forEach((otherItem) => {
            if (otherItem !== item) {
                otherItem.classList.remove("active");
            }
        });
        item.classList.toggle("active");
    });
});
